import { render, staticRenderFns } from "./AwardTrophy.vue?vue&type=template&id=4d6a9ca8&"
import script from "./AwardTrophy.vue?vue&type=script&lang=js&"
export * from "./AwardTrophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports